(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    // document.querySelectorAll('p').forEach( e => {
    //     if (e.innerHTML === '') e.remove();	
    // });

    $('.request-btn').click(function() {
        var tab = $(this).attr('href');
        
        if($(this).hasClass('expanded-form')) {
            $(tab).hide();
            $(this).removeClass('expanded-form');
        } else {
            $(tab).show();
            $(this).addClass('expanded-form');
        }
    });
    
    $('.sym-slides').slick(); 

    $('.book-specials').on('click', function(e) {
        e.preventDefault();
        var destinationUrl = $(this).attr('href');
        ga(function(tracker) {
            var linker = new window.gaplugins.Linker(tracker);
            var output = linker.decorate(destinationUrl, true);
            ga('send', 'event', 'specials page hotel only ', 'click', 'book now');
            window.open(output, '_blank');
        });
    });
    $('.book-pop-up').on('click', function(e) {
        e.preventDefault();
        var destinationUrl = $(this).attr('href');
        ga(function(tracker) {
            var linker = new window.gaplugins.Linker(tracker);
            var output = linker.decorate(destinationUrl, true);
            ga('send', 'event', 'popup', 'click', 'book now spring getaway');
            window.open(output, '_blank');
        });
    });
    $('.book-now-notracking').on('click', function(e) {
        e.preventDefault();
        var destinationUrl = $(this).attr('href');
        console.log('cross domain tracking');
        ga(function(tracker) {
            var linker = new window.gaplugins.Linker(tracker);
            var output = linker.decorate(destinationUrl, true);
            window.open(output, '_blank');
        });
    });
    $('.book-rooms').on('click', function(e) {
        e.preventDefault();
        var destinationUrl = $(this).attr('href');
        ga(function(tracker) {
            var linker = new window.gaplugins.Linker(tracker);
            var output = linker.decorate(destinationUrl, true);
            ga('send', 'event', 'accommodations page hotel only ', 'click', 'book now');
            window.open(output, '_blank');
        });
    });

    jQuery(function($) {
        // $('a[href*="#"]:not([href="#"])').click(function() {
        //     var target = $(this.hash);
        //         $('html,body').stop().animate({
        //         scrollTop: target.offset().top - 100
        //         }, 1100);   
        // });    
        if (location.hash){
        var id = $(location.hash);
        }
        $(window).on('load', function() {
        if (location.hash){
            $('html,body').animate({scrollTop: id.offset().top -150}, 600)
        };
        });
    });

}());

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('.floating-menu');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}


document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();


    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.floating-menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});